import CreateDocument from "../../components/CreateDocument";
function CreateDocumentPage() {
  return (
    <div>
      <CreateDocument />
    </div>
  );
}

export default CreateDocumentPage;
